(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/templates/product-page-onboarding/assets/javascripts/fullscreen-mount.js') >= 0) return;  svs.modules.push('/templates/product-page-onboarding/assets/javascripts/fullscreen-mount.js');
"use strict";

var _svs$onboarding;

const {
  onboardingDomain
} = svs.components.onboarding.core.utils;
const {
  createFullscreenEventHandler
} = svs.components.onboarding.core.events.eventHandlers;
const {
  FullscreenEventType
} = svs.components.onboarding.core.events.constants;
const {
  TemplateSelectors
} = svs.templates.productPageOnboarding.constants;
const {
  setItem,
  getItem
} = svs.templates.productPageOnboarding.sessionStorage;


const mainContentEl = document.querySelector('.main-content');
const onboardingFullscreenEl = document.querySelector(TemplateSelectors.TemplateFullscreen);
const bodyContentEl = document.body;
const {
  key,
  count,
  displaycount
} = ((_svs$onboarding = svs.onboarding) === null || _svs$onboarding === void 0 || (_svs$onboarding = _svs$onboarding.fullscreen) === null || _svs$onboarding === void 0 ? void 0 : _svs$onboarding.data) || {};
if (mainContentEl && onboardingFullscreenEl && key) {
  const {
    hasTriggered
  } = getItem(key) || {
    hasTriggered: false
  };
  if (!hasTriggered) {
    const {
      addEventListener: addFullscreenEventListener,
      dispatchEvent: dispatchFullscreenEvent
    } = createFullscreenEventHandler();
    const {
      setCount
    } = onboardingDomain(svs.core.data.module, svs.core.data.baseUrl);
    const updateCount = () => {
      if (displaycount > 0 && count < displaycount) {
        setCount(key, count + 1);
      }
    };
    const showOnboardingFullscreen = () => {
      bodyContentEl.classList.add('onboarding-fullscreen--show', 'body-content--hide');
    };
    const hideOnboardingFullscreen = () => {
      bodyContentEl.classList.remove('onboarding-fullscreen--show', 'body-content--hide');
    };
    const cleanupFullscreen = () => {
      hideOnboardingFullscreen();
      if (onboardingFullscreenEl && onboardingFullscreenEl.parentElement) {
        onboardingFullscreenEl.parentElement.removeChild(onboardingFullscreenEl);
      }
    };
    const onCloseFullscreen = () => {
      dispatchFullscreenEvent(new svs.components.onboarding.core.events.HideFullscreenEvent());
      cleanupFullscreen();
    };
    addFullscreenEventListener(FullscreenEventType.Show, e => {
      const FullscreenComponent = e.detail.component;
      ReactDOM.render(React.createElement(FullscreenComponent, {
        onCloseFullscreen: onCloseFullscreen
      }), onboardingFullscreenEl);
      updateCount();
      setItem(key, {
        hasTriggered: true
      });
      showOnboardingFullscreen();
    });
    addFullscreenEventListener(FullscreenEventType.Hide, () => {
      cleanupFullscreen();
    });
  }
}

 })(window);